export const PREFIX = 'userSettings'
